module.exports = __webpack_public_path__ + "img/horizontal_4_7_9016.cd66cedb.png";